import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Devicepersian_Interface, Empty_Devicepersian_Interface } from 'src/app/Interface/Devicepersian_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { DevicepersianService } from 'src/app/Service/Devicepersian/Devicepersian.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DevicepersianEdit',
  templateUrl: './DevicepersianEdit.component.html',
  styleUrls: ['./DevicepersianEdit.component.scss']
})
export class DevicepersianEditComponent implements OnInit {

  Token:String=""
  EditRecord:Number
  Selected_Price_Record:Devicepersian_Interface=Empty_Devicepersian_Interface();

  constructor(
    private Devicepersian_Service:DevicepersianService,
    private Nav_Service:NavService,
    private Device_Service:DeviceService,
    private modalService: BsModalService,
    private Alertify_Service:AlertifyService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.EditDevicepersian=new FormGroup({
      id :new FormControl(),
      Dsc:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))

    this.Nav_Service.CheckValidPage(this.Token,1080).subscribe(
      data=>{
        this.Devicepersian_Service.GetSingle(this.Token,this.EditRecord).subscribe(
          data=>{
            this.get_Form_Dsc().setValue(data.dsc)
            this.Selected_Price_Record=data

          }
        )
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  EditDevicepersian:FormGroup;

  get_Form_Dsc(){
    return this.EditDevicepersian.get('Dsc') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitEditDevicepersian(){
    var Record:Devicepersian_Interface =Empty_Devicepersian_Interface()
    Record.id=this.Selected_Price_Record.id
    Record.dsc=this.get_Form_Dsc().value
    this.InProccessing=true
    this.Devicepersian_Service.EditDevicepersian(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered Persian title already exists in the list.")
        }
        else{
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
